import { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import styles from "./UnitPriceForm.module.css";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";

const UnitPriceForm = ({ unitPrices, onSave }) => {
  const [showCard, setShowCard] = useState(false);
  const [unitPriceForms, setUnitPriceForms] = useState([
    {
      type: "new",
      StartRange: "0",
      EndRange: "",
      Steps: "1",
      Marketplace_price: "",
      Industry_price: "",
      Vendor_price: "",
      Min_price: "",
      Max_price: "",
      hsn_code: "",
      DefaultValue: true,
      changed_unitprice: false,
    },
  ]);
  const [unitPriceErrors, setUnitPriceErrors] = useState({});

  useEffect(() => {
    if (unitPrices && unitPrices.length) {
      const withIds = unitPrices.map((u, i) => ({
        ...u,
        id: u.id ?? Date.now() + i,
        type: "existing",
        changed_unitprice: u.changed_unitprice ?? false,
      }));
      setUnitPriceForms(withIds);
    }
  }, [showCard, unitPrices]);

  const validateUnitPriceForms = (forms) => {
    const errors = {};
    let isValid = true;

    forms.forEach((form, index) => {
      const rowErrors = {};
      const requiredFields = ["Marketplace_price"];
      requiredFields.forEach((field) => {
        const value = form[field];
        if (value === "" || value === null || value === undefined) {
          rowErrors[field] = true;
          isValid = false;
        }
      });
      if (Object.keys(rowErrors).length > 0) {
        errors[index] = rowErrors;
      }
    });
    if (Object.keys(errors).length) {
      toast.error("Add all required feilds");
      setUnitPriceErrors(errors);
    }
    return isValid;
  };

  const handleSave = () => {
    const isValid = validateUnitPriceForms(unitPriceForms);
    if (!isValid) {
      return;
    }
    setShowCard(false);
    onSave(unitPriceForms);
    return;
  };

  const handleChange = (index, e) => {
    const { name, value, type } = e.target;
    const realValue =
      type === "number" ? (value === "" ? "" : Number(value)) : value;
    let updatedForms;
    updatedForms = unitPriceForms.map((form, i) =>
      i === index ? { ...form, [name]: realValue } : form,
    );
    setUnitPriceForms(updatedForms);
    setUnitPriceErrors((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [name]: false,
      },
    }));
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.EditUnitPrice}
        onClick={(e) => {
          e.preventDefault();
          setShowCard(true);
        }}
        aria-haspopup="dialog"
        aria-expanded={showCard}
      >
        <FaEdit />
      </button>
      {showCard && (
        <div className={styles.unitPriceContainer}>
          <div
            className={styles.dropShadow}
            onClick={() => setShowCard(false)}
            aria-hidden="true"
          />
          <div
            className={styles.unitPricefield}
            role="dialog"
            aria-modal="true"
            aria-label="Unit Prices"
            onKeyDown={(e) => {
              if (e.key === "Escape") setShowCard(false);
            }}
          >
            <div className={styles.unitBody}>
              {unitPriceForms.length !== 0 ? (
                <>
                  {unitPriceForms.map((form, index) => (
                    <Form
                      key={index}
                      className={styles.card}
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className={styles.unitPriceTop}>
                        <h1 className={styles.heading}>Unit Price</h1>
                      </div>
                      <div className={styles.cardBody}>
                        <Row>
                          <Col md={4}>
                            <Form.Group controlId={`formStartRange-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                Start Range
                              </Form.Label>
                              <Form.Control
                                required
                                type="number"
                                readOnly
                                name="StartRange"
                                value={form.StartRange}
                                className={`${styles.formControl} `}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formEndRange-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                End Range
                              </Form.Label>
                              <Form.Control
                                required
                                type="number"
                                readOnly
                                name="EndRange"
                                value={form.EndRange}
                                className={`${styles.formControl}`}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group
                              controlId={`formMarketplacePrice-${index}`}
                            >
                              <Form.Label className={styles.unitPriceLabel}>
                                Marketplace Price
                              </Form.Label>
                              <Form.Control
                                required
                                type="number"
                                step="0.01"
                                name="Marketplace_price"
                                value={form.Marketplace_price}
                                onChange={(e) => handleChange(index, e)}
                                onWheel={(e) => e.target.blur()}
                                className={`${styles.formControl} ${
                                  unitPriceErrors[index]?.Marketplace_price
                                    ? styles.inputError
                                    : ""
                                }`}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <Form.Group
                              controlId={`formIndustryPrice-${index}`}
                            >
                              <Form.Label className={styles.unitPriceLabel}>
                                Industry Price
                              </Form.Label>
                              <Form.Control
                                type="number"
                                readOnly
                                step="0.01"
                                name="Industry_price"
                                value={form.Industry_price}
                                className={`${styles.formControl}`}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formVendorPrice-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                Vendor Price
                              </Form.Label>
                              <Form.Control
                                type="number"
                                readOnly
                                step="0.01"
                                name="Vendor_price"
                                value={form.Vendor_price}
                                className={`${styles.formControl} `}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formMinPrice-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                Min Price
                              </Form.Label>
                              <Form.Control
                                type="number"
                                readOnly
                                step="0.01"
                                name="Min_price"
                                value={form.Min_price}
                                placeholder="Min Price"
                                className={`${styles.formControl}`}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <Form.Group controlId={`formMaxPrice-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                Max Price
                              </Form.Label>
                              <Form.Control
                                type="number"
                                readOnly
                                step="0.01"
                                name="Max_price"
                                value={form.Max_price}
                                placeholder="Max Price"
                                className={`${styles.formControl}`}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formMaxPrice-${index}`}>
                              <Form.Label className={styles.unitPriceLabel}>
                                HSN Code
                              </Form.Label>
                              <Form.Control
                                type="string"
                                readOnly
                                name="hsn_code"
                                value={form.hsn_code}
                                className={`${styles.formControl}`}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  ))}
                  <Button className={styles.submitBtn} onClick={handleSave}>
                    Save
                  </Button>
                </>
              ) : (
                <p>No Unit Price available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UnitPriceForm;
